module.exports = __webpack_public_path__ + "static/img/图层27.c00d5c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层27.png
// module id = 8LK3
// module chunks = 0